import mixpanel from 'mixpanel-browser';

let initialized = false;

export const initTracking = () => {
  if (initialized) return;
  mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN);
  window.dataLayer = window.dataLayer || [];
  initialized = true;
};

export const trackEvent = (eventName, properties = {}) => {
  // Guards against React's child-before-parent useEffect order: a page's
  // "Page Viewed" effect can fire before App's initTracking() effect.
  initTracking();
  const utms = getStoredUtms();
  const props = { ...utms, ...properties };
  mixpanel.track(eventName, props);
  window.dataLayer.push({ event: eventName, ...props });
};

export const getStoredUtms = () => {
  try { return JSON.parse(sessionStorage.getItem('tp_utms')) || {}; }
  catch { return {}; }
};

export const captureUtms = () => {
  const params = new URLSearchParams(window.location.search);
  const utms = {};
  ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(k => {
    if (params.get(k)) utms[k] = params.get(k);
  });
  if (Object.keys(utms).length) sessionStorage.setItem('tp_utms', JSON.stringify(utms));
};
